import { render } from "./VideoTranscoder.vue?vue&type=template&id=19e8739e&ts=true"
import script from "./VideoTranscoder.vue?vue&type=script&lang=ts"
export * from "./VideoTranscoder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__